/** @file TINY_FONT: a 3x5 pixel font for labels drawn into images (digits, a-z, a few signs). */

/**
 * Glyph rows top to bottom, `#` = ink, rows separated by spaces; letters are lower case only (`drawText` folds case).
 * Each glyph is 3 px wide and 5 px tall; text advances 4 px per character.
 */
export const TINY_FONT: Readonly<Record<string, string>> = {
  '0': '### #.# #.# #.# ###', '1': '.#. ##. .#. .#. ###', '2': '### ..# ### #.. ###', '3': '### ..# .## ..# ###',
  '4': '#.# #.# ### ..# ..#', '5': '### #.. ### ..# ###', '6': '### #.. ### #.# ###', '7': '### ..# ..# .#. .#.',
  '8': '### #.# ### #.# ###', '9': '### #.# ### ..# ###',
  a: '.#. #.# ### #.# #.#', b: '##. #.# ##. #.# ##.', c: '.## #.. #.. #.. .##', d: '##. #.# #.# #.# ##.',
  e: '### #.. ##. #.. ###', f: '### #.. ##. #.. #..', g: '.## #.. #.# #.# .##', h: '#.# #.# ### #.# #.#',
  i: '### .#. .#. .#. ###', j: '..# ..# ..# #.# .#.', k: '#.# #.# ##. #.# #.#', l: '#.. #.. #.. #.. ###',
  m: '#.# ### ### #.# #.#', n: '##. #.# #.# #.# #.#', o: '.#. #.# #.# #.# .#.', p: '##. #.# ##. #.. #..',
  q: '.#. #.# #.# ### .##', r: '##. #.# ##. #.# #.#', s: '.## #.. .#. ..# ##.', t: '### .#. .#. .#. .#.',
  u: '#.# #.# #.# #.# ###', v: '#.# #.# #.# #.# .#.', w: '#.# #.# ### ### #.#', x: '#.# #.# .#. #.# #.#',
  y: '#.# #.# .#. .#. .#.', z: '### ..# .#. #.. ###',
  '.': '... ... ... ... .#.', _: '... ... ... ... ###', '-': '... ... ### ... ...', ':': '... .#. ... .#. ...',
  '/': '..# ..# .#. #.. #..', '=': '... ### ... ### ...', '>': '#.. .#. ..# .#. #..', '(': '.#. #.. #.. #.. .#.',
  ')': '.#. ..# ..# ..# .#.', ' ': '... ... ... ... ...', '?': '### ..# .#. ... .#.',
};
